import ArrowIcon from '@/components/ui/icons/arrow-icon';
import InfoIcon from '@/components/icons/InfoIcon';
import PhonePlusIcon from '@/components/icons/PhonePlusIcon';
import PhoneIcon from '@/components/icons/PhoneIcon';
import WhatsappIcon from '@/components/icons/WhatsappIcon';
import EmailIcon from '@/components/icons/EmailIcon';
import { useTranslations } from 'next-intl';
import ResponsiveCategories from './ResponsiveCategories';
import LocationPinIcon from '@/components/icons/LocationPinIcon';
import LocaleSwitcher from '@/components/ui/local-switcher';
import { useRouter } from '@/i18n/navigation';
import { useSession } from 'next-auth/react';
import NextLink from '@/components/next-link';

const MenuContent = ({ onClose, setAuth }) => {
  const t = useTranslations('common');

  const { data: session } = useSession();
  const { push } = useRouter();
  // Help options data
  const contactOptions = [
    {
      icon: <PhoneIcon className='shrink-0' />,
      text: 'Call us',
      href: 'tel:+966558930979',
    },
    {
      icon: <WhatsappIcon className='shrink-0' />,
      text: 'whatsapp',
      href: 'https://wa.me/966558930979',
    },
    {
      icon: <EmailIcon className='shrink-0' />,
      text: 'Email',
      href: 'mailto:support@parisgalleryksa.com',
    },
  ];

  // Footer links data
  const footerLinks = [
    { name: 'Shipping Policy', link: '/static/shipping-policy' },
    { name: 'Returns & Refunds', link: '/static/cancellation-return-policy' },
    { name: 'Frequently Asked Questions', link: '/static/faqs' },
  ];

  return (
    <div className='w-full'>
      <div className='flex h-full flex-col'>
        {/* Header */}
        <div
          onClick={() => {
            !session?.user ? setAuth('login-email') : push('/user');
            onClose();
          }}
          className='flex items-center justify-between border-b border-neutral-200 p-3'
        >
          <h2 className='text-xs leading-6 font-bold text-black'>
            {t('My Account')}
          </h2>
          <ArrowIcon
            className='size-2.5 rotate-270 rtl:rotate-90'
            strokeWidth={2}
          />
        </div>

        {/* Categories Section */}
        <ResponsiveCategories onClose={onClose} />

        {/* Our Offers Section */}
        <div className='flex items-center justify-between border-b border-neutral-200 p-3'>
          <h2 className='text-xs leading-6 font-bold text-black'>
            {t('Our Offers')}
          </h2>
          <ArrowIcon
            className='size-2.5 rotate-270 rtl:rotate-90'
            strokeWidth={2}
          />
        </div>

        {/* Our Brands Section */}
        <NextLink
          href='/brands'
          onClick={() => onClose()}
          className='flex items-center justify-between border-b border-neutral-200 p-3'
        >
          <h2 className='text-xs leading-6 font-bold text-black'>
            {t('Our Brands')}
          </h2>
          <ArrowIcon
            className='size-2.5 rotate-270 rtl:rotate-90'
            strokeWidth={2}
          />
        </NextLink>

        {/* Help Section */}
        <NextLink
          href='/contact-us'
          onClick={() => onClose()}
          className='flex items-center justify-between p-4'
        >
          <div className='flex items-center gap-2'>
            <InfoIcon />
            <span className='text-xs font-normal text-black'>{t('Help')}</span>
          </div>
          <ArrowIcon
            className='size-2.5 rotate-270 rtl:rotate-90'
            strokeWidth={2}
          />
        </NextLink>

        {/* Locations Section */}
        <NextLink
          href='/branches'
          onClick={() => onClose()}
          className='flex items-center justify-between p-4'
        >
          <div className='flex items-center gap-2'>
            <LocationPinIcon />
            <span className='text-xs font-normal text-black'>
              {t('Our Locations')}
            </span>
          </div>
          <ArrowIcon
            className='size-2.5 rotate-270 rtl:rotate-90'
            strokeWidth={2}
          />
        </NextLink>

        {/* Language Section */}
        <LocaleSwitcher isSide onClose={onClose} />

        {/* Need Help Section */}
        <div className='p-4'>
          <div className='flex items-center gap-2'>
            <PhonePlusIcon />
            <span className='text-xs font-normal text-black'>
              {t('Need Help')}
            </span>
          </div>

          <p className='mt-2 text-[10px] leading-4 text-[#898989]'>
            {t('Need Help Description')}
          </p>

          <div className='mt-4 flex items-center gap-3'>
            {contactOptions.map((option, index) => (
              <NextLink
                key={index}
                href={option.href}
                onClick={() => onClose()}
                className='flex h-[31px] w-auto items-center justify-center gap-2 rounded-sm border border-[#e6e3e3] p-0 px-3 text-[9px] font-normal text-black'
              >
                {option.icon}
                <span className='text-nowrap'>{t(option.text)}</span>
              </NextLink>
            ))}
          </div>
        </div>

        {/* Footer Links */}
        <div>
          {footerLinks.map((link, index) => (
            <NextLink
              href={link.link}
              onClick={() => onClose()}
              key={index}
              className='flex items-center justify-between p-4'
            >
              <span className='text-xs font-normal text-black'>
                {t(link.name)}
              </span>
              <ArrowIcon
                className='size-2.5 rotate-270 rtl:rotate-90'
                strokeWidth={2}
              />
            </NextLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuContent;
